import { graphql } from '@generated/gql';

export const VALIDATE_AGE_OF_MAJORITY = graphql(/** GraphQL */ `
  query validateAgeOfMajority(
    $dateOfBirth: String!
    $country: AddressCountries!
    $jurisdiction: AddressJurisdiction
  ) {
    validateAgeOfMajority(
      dateOfBirth: $dateOfBirth
      country: $country
      jurisdiction: $jurisdiction
    ) {
      valid
      ageOfMajority
    }
  }
`);
